import { formatPrice } from "@/lib/store";
import { installmentText, planValues, productPlans, promoOf, useRates } from "@/lib/pricing";

const SIZES = {
  page: { price: "text-4xl sm:text-5xl font-extrabold", old: "text-base", inst: "text-base sm:text-lg" },
  featured: { price: "text-4xl sm:text-5xl font-extrabold", old: "text-base", inst: "text-lg" },
  card: { price: "text-2xl font-bold", old: "text-sm", inst: "text-sm" },
  compact: { price: "text-lg font-bold", old: "text-xs", inst: "text-[13px]" },
};

export const OfferBadge = ({ testid }) => (
  <span data-testid={testid} className="inline-flex w-fit items-center rounded-full bg-[#25D366] px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.14em] text-black">
    Oferta imperdível
  </span>
);

const PlanList = ({ p }) => (
  <ul data-testid="product-page-installments" className="mt-2 space-y-0.5 text-sm text-zinc-300">
    {productPlans(p).map((pl) => (
      <li key={pl.id} data-testid={`product-plan-${pl.id}`}>ou {pl.n}x de {formatPrice(planValues(p.price, pl).each)}</li>
    ))}
  </ul>
);

export const PriceBlock = ({ p, size = "card", priceTestid, installmentTestid, end = false }) => {
  useRates();
  const s = SIZES[size];
  const promo = promoOf(p);
  const inst = installmentText(p);
  const detailed = (size === "page" || size === "featured") && productPlans(p).length > 0;
  return (
    <div className={`flex flex-col ${end ? "items-end text-right" : ""}`}>
      {promo && <OfferBadge testid={`${priceTestid}-offer`} />}
      {promo && <p data-testid={`${priceTestid}-old`} className={`${size === "compact" ? "mt-1" : "mt-2"} ${s.old} text-zinc-400 line-through`}>{formatPrice(promo.old)}</p>}
      <div className={`flex flex-wrap items-center gap-2 ${end ? "justify-end" : ""}`}>
        <p data-testid={priceTestid} className={`font-display leading-tight text-white ${s.price}`}>{formatPrice(p.price)}</p>
        {promo && <span data-testid={`${priceTestid}-discount`} className="rounded-md bg-emerald-400/15 px-1.5 py-0.5 text-xs font-bold text-emerald-300">-{promo.pct}%</span>}
      </div>
      {detailed ? <PlanList p={p} /> : inst && <p data-testid={installmentTestid} className={`mt-0.5 ${s.inst} text-zinc-300`}>ou {inst}</p>}
    </div>
  );
};
